"use client"

import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"

import { labelFieldVariants, type LabelFieldVariantProps } from "@/components/ui/field-variants"
import { cn } from "@/lib/utils"

type LabelProps = React.ComponentProps<typeof LabelPrimitive.Root> & LabelFieldVariantProps

const Label = ({ className, variant = "floating", ...props }: LabelProps) => {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      data-variant={variant}
      className={cn(labelFieldVariants({ variant }), className)}
      {...props}
    />
  )
};

export { Label }
